export const basePath = '/mypage'

const routes = {
  root: basePath,
  main: (): string => basePath,
}

export default routes
